var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCardOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.125 8.75C6.39911 8.75 5 10.1491 5 11.875V28.125C5 29.8509 6.39911 31.25 8.125 31.25H31.875C33.6009 31.25 35 29.8509 35 28.125V11.875C35 10.1491 33.6009 8.75 31.875 8.75H8.125ZM2.5 11.875C2.5 8.7684 5.0184 6.25 8.125 6.25H31.875C34.9816 6.25 37.5 8.7684 37.5 11.875V28.125C37.5 31.2316 34.9816 33.75 31.875 33.75H8.125C5.0184 33.75 2.5 31.2316 2.5 28.125V11.875Z",
    fill: "#08152C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.25 17.3438H3.75V12.6562H36.25V17.3438ZM7.65625 23.4375C7.65625 22.1431 8.70558 21.0938 10 21.0938H13.75C15.0444 21.0938 16.0938 22.1431 16.0938 23.4375V25C16.0938 26.2944 15.0444 27.3438 13.75 27.3438H10C8.70558 27.3438 7.65625 26.2944 7.65625 25V23.4375Z",
    fill: "#08152C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardOutline);
export default __webpack_public_path__ + "static/media/card-outline.7c2f01c12d2fbc33435be3399cbd2127.svg";
export { ForwardRef as ReactComponent };